var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 17.25,
    viewBox: "0 0 16.5 17.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_41460",
    "data-name": "Caminho 41460",
    d: "M6.75-18v.75h-3V-.75h16.5v-16.5h-3V-18h-1.5v.75H8.25V-18Zm-1.5,2.25h1.5V-15h1.5v-.75h7.5V-15h1.5v-.75h1.5v1.5H5.25Zm0,3h13.5v10.5H5.25Zm4.5,1.5v1.5h1.5v-1.5Zm3,0v1.5h1.5v-1.5Zm3,0v1.5h1.5v-1.5Zm-9,3v1.5h1.5v-1.5Zm3,0v1.5h1.5v-1.5Zm3,0v1.5h1.5v-1.5Zm3,0v1.5h1.5v-1.5Zm-9,3v1.5h1.5v-1.5Zm3,0v1.5h1.5v-1.5Zm3,0v1.5h1.5v-1.5Z",
    transform: "translate(-3.75 18)",
    fill: "#9d9dc4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.4641f979c5dd5cc75d064cea778e9adf.svg";
export { ForwardRef as ReactComponent };